import { Controller, Shark, Utils } from "shark-mvc";
// import { NousCore } from "nouscore-js-api";
// import moment from "moment";
import { userManager } from "./userManager";
import followUpManager from "./followUpManager";
// import { notComplianceReportEditView } from "../../views/constructionSite/notComplianceReportEditView";

class CommunicationManager extends Controller {
	constructor() {
		super("communicationManager");
	}

	leadPremiumInserted (currLead) {
		return new Promise((resolve) => {
			let assignee = currLead.__agentFullName !== "" ? `Il Lead è stato assegnato a ${currLead.__agentFullName}.` : "Il Lead non è ancora stato assegnato.";

			const body = `BuonGiorno Andrea,
						
				questa eMail per comunicarti che è stato inserito un nuovo <em>Lead Premium</em>: <strong>${currLead.name}</strong>.
				<br>${assignee}

				Buona Giornata,
				IPM HUB
			`;

			const currMessage = Shark.getInstance(null, {
				body,
				senderEMail: "hub-noreply@ipmitalia.it",
				senderName: "IPM HUB",
				subject: "IPM HUB | Nuovo Lead Premium",
				receiverEMail: "andrea.penati@ipmitalia.it",
				receiverName: "Andrea Penati",
			});
			userManager.sendMessage(currMessage);
			resolve({ status: "ok" });
		});
	}

	notComplianceReportInsertAgent (currUser, currConstructionSite, currNotComplianceReport) {
		return new Promise((resolve) => {
			const body = `BuonGiorno Marco,
						
				questa eMail per comunicare che è stata aperta la Non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> relativa al Cantiere <strong>${currConstructionSite.__siteLocationLabel}</strong> con partenza prevista il <strong>${currConstructionSite.__startDateLabel}</strong> per <strong>${currConstructionSite.registry.clientName}</strong>.

				Buona Giornata,
				IPM HUB
			`;

			const currMessage = Shark.getInstance(null, {
				body,
				senderEMail: currUser.email,
				senderName: currUser.__fullName,
				subject: "IPM HUB | Apertura Non Conformità",
				receiverEMail: "fabrizio.penati@ipmitalia.it",
				receiverName: "Marco Cereda",
			});
			userManager.sendMessage(currMessage);

			const newFollowUp = Shark.getInstance("ClientFollowUp", {
				body: `Aperta la Non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> per <strong>${currConstructionSite.__siteLocationLabel}</strong>.`,
				clientGuid: currConstructionSite.clientGuid,
				referenceGuid: currConstructionSite.guid,
				referenceType: "constructionSite",
				status: 3,
				type: "system"
			});

			followUpManager.save(newFollowUp)
			.then(() => {
				resolve({
					status: "ok"
				});
			});
		});
	}

	notComplianceReportUpdateAgent (currUser, currConstructionSite, currNotComplianceReport) {
		return new Promise((resolve) => {
			let body = `BuonGiorno Marco,
						
				questa eMail per comunicare che ${currUser.__fullName} ha modificato la Non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> relativa al Cantiere <strong>${currConstructionSite.__siteLocationLabel}</strong> con partenza prevista il <strong>${currConstructionSite.__startDateLabel}</strong> per <strong>${currConstructionSite.registry.clientName}</strong>.

				Buona Giornata,
				IPM HUB
			`;

			let currMessage = Shark.getInstance(null, {
				body,
				senderEMail: currUser.email,
				senderName: currUser.__fullName,
				subject: "IPM HUB | Modifica Non Conformità",
				receiverEMail: "fabrizio.penati@ipmitalia.it",
				receiverName: "Marco Cereda",
			});
			userManager.sendMessage(currMessage);

			body = `BuonGiorno Barbara,
							
				questa eMail per comunicare che ${currUser.__fullName} ha modificato la Non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> relativa al Cantiere <strong>${currConstructionSite.__siteLocationLabel}</strong> con partenza prevista il <strong>${currConstructionSite.__startDateLabel}</strong> per <strong>${currConstructionSite.registry.clientName}</strong>.

				Buona Giornata,
				IPM HUB
			`;

			currMessage = Shark.getInstance(null, {
				body,
				senderEMail: currUser.email,
				senderName: currUser.__fullName,
				subject: "IPM HUB | Modifica Non Conformità",
				receiverEMail: "barbara.marinelli@ipmitalia.it",
				receiverName: "Barbara Marinelli",
			});
			userManager.sendMessage(currMessage);

			const newFollowUp = Shark.getInstance("ClientFollowUp", {
				body: `Modificata la Non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> per <strong>${currConstructionSite.__siteLocationLabel}</strong>.`,
				clientGuid: currConstructionSite.clientGuid,
				referenceGuid: currConstructionSite.guid,
				referenceType: "constructionSite",
				status: 3,
				type: "system"
			});

			followUpManager.save(newFollowUp)
			.then(() => {
				resolve({
					status: "ok"
				});
			});
		});
	}

	notComplianceReportSetAsReadyForCSIPM (currNotComplianceReport) {
		return new Promise((resolve) => {
			const currUser = Shark.get("currUser");

			if (currUser.__fullName !== "Barbara Marinelli") {//Dave: Sempre più dovremmo gestire questa cosa con gli user e una qualche proprietà che li imposti come "destinatari" di certe eMail
				const body = `BuonGiorno Barbara,
				
					questa eMail per comunicare che ${currUser.__fullName} ha modificato il Report di non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> relativo al Cantiere <strong>${currNotComplianceReport.__siteLocationLabel}</strong> per <strong>${currNotComplianceReport.clientName}</strong>.

					Il Report di non Conformità è ora <strong>idoneo per il Cantiere</strong>, per favore imposta la <strong>CCA</strong> e inserisci il <strong>Foglio Lavoro Cantiere</strong>.
					
					Buona Giornata,
					IPM HUB
				`;
				
				const currMessage = Shark.getInstance(null, {
					body,
					senderEMail: currUser.email,
					senderName: currUser.__fullName,
					subject: "IPM HUB | Non Conformità promossa a Idonea per il Cantiere",
					receiverEMail: "barbara.marinelli@ipmitalia.it",
					receiverName: "Barbara Marinelli",
				});
				userManager.sendMessage(currMessage);
			}

			const newFollowUp = Shark.getInstance("ClientFollowUp", {
				body: `Il Rapporto di non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> è stato promosso a <strong>idoneo per il cantiere</strong>`,
				clientGuid: currNotComplianceReport.clientGuid,
				referenceGuid: currNotComplianceReport.guid,
				referenceType: "notComplianceReport",
				status: 3,
				type: "system"
			});

			followUpManager.save(newFollowUp)
			.then(() => {
				resolve({
					status: "ok"
				});
			});
		});
	}

	notComplianceReportUpdateIPM (currUser, currConstructionSite, currNotComplianceReport) {
		return new Promise((resolve) => {
			const referenceAgent = Utils.safp(Shark.get("userList"), "guid", currConstructionSite.userGuid);

			if (referenceAgent) {
				const body = `BuonGiorno ${referenceAgent.firstName},
							
					questa eMail per comunicare che ${currUser.__fullName} ha modificato la Non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> relativa al Cantiere <strong>${currConstructionSite.__siteLocationLabel}</strong> con partenza prevista il <strong>${currConstructionSite.__startDateLabel}</strong> per <strong>${currConstructionSite.registry.clientName}</strong>.

					Buona Giornata,
					IPM HUB
				`;

				const currMessage = Shark.getInstance(null, {
					body,
					senderEMail: currUser.email,
					senderName: currUser.__fullName,
					subject: "IPM HUB | Modifica Non Conformità",
					receiverEMail: referenceAgent.email,
					receiverName: referenceAgent.__fullName,
				});
				userManager.sendMessage(currMessage);
			}

			if (currUser.__fullName !== "Barbara Marinelli") {//Dave: Sempre più dovremmo gestire questa cosa con gli user e una qualche proprietà che li imposti come "destinatari" di certe eMail
				const body = `BuonGiorno Barbara,
				
					questa eMail per comunicare che ${currUser.__fullName} ha modificato la Non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> relativa al Cantiere <strong>${currConstructionSite.__siteLocationLabel}</strong> con partenza prevista il <strong>${currConstructionSite.__startDateLabel}</strong> per <strong>${currConstructionSite.registry.clientName}</strong>.
					
					Buona Giornata,
					IPM HUB
					`;
				
				const currMessage = Shark.getInstance(null, {
					body,
					senderEMail: currUser.email,
					senderName: currUser.__fullName,
					subject: "IPM HUB | Modifica Non Conformità",
					receiverEMail: "barbara.marinelli@ipmitalia.it",
					receiverName: "Barbara Marinelli",
				});
				userManager.sendMessage(currMessage);
			}

			const newFollowUp = Shark.getInstance("ClientFollowUp", {
				body: `Modificata la Non Conformità <strong>${currNotComplianceReport.__numberLabel}</strong> per <strong>${currConstructionSite.__siteLocationLabel}</strong>.`,
				clientGuid: currConstructionSite.clientGuid,
				referenceGuid: currConstructionSite.guid,
				referenceType: "constructionSite",
				status: 3,
				type: "system"
			});

			followUpManager.save(newFollowUp)
			.then(() => {
				resolve({
					status: "ok"
				});
			});
		});
	}

	quotationSetAsRefused (quotation, quotationAgent) {
		return new Promise((resolve, reject) => {
			const { currUser } = Shark.get();
			// const userList = Shark.get("userList");
			const messageList = [];
			// let areaManager;
			let refuseReason = quotation.extraData.refuseReason;
			refuseReason = refuseReason !== "" ? `<br>È stata inserita la seguente motivazione: <q>${refuseReason}</q>` : "";

			// if (currUser.preferences.areaManagerGuid && currUser.preferences.areaManagerGuid !== "") {
			// 	areaManager = Utils.safp(userList, "guid", currUser.preferences.areaManagerGuid);
			// }

			const body = `BuonGiorno [[receiver.firstName]],

				questa eMail per comunicare che il preventivo <strong>${quotation.code}${quotation.pdfURL ? " (" + quotation.pdfURL.substr(53) + ")" : ""}</strong>, relativo alla scheda informativa del <strong>${quotation.__siteInfoSheetDate}</strong> per <strong>${quotation.clientName}</strong> è stato impostato come <span style="color: red;">rifiutato</span> da ${currUser.__fullName}.${refuseReason}

				Puoi visualizzare il Preventivo <a class="nlLink" href="${Shark.get("__cdnURL")}/${quotation.pdfURL}">cliccando qui</a>.
				
				Puoi visualizzare la lista dei Preventivi <a class="nlLink" href="${Shark.get("agentAppURL")}/#quotationListView">cliccando qui</a>.

				Buona Giornata,
				IPM HUB
			`;

			let currMessage = Shark.getInstance("__smart__", {
				body: body.replace("[[receiver.firstName]]", quotationAgent.firstName),
				senderEMail: currUser.email,
				senderName: currUser.__fullName,
				subject: "IPM HUB | Preventivo rifiutato",
				receiverEMail: quotationAgent.email,
				receiverName: quotationAgent.__fullName,
			});
			messageList.push(currMessage);

			// if (areaManager) {
			// 	currMessage = this.prepareMessage(currUser, areaManager, "IPM HUB | Preventivo rifiutato", body);
			// 	messageList.push(currMessage);
			// }

			userManager.sendMessages(messageList)
			.then(sendMessagesResponse => {
				console.log(sendMessagesResponse);
				resolve({
					status: "ok"
				});
			});
		});
	}

	sampleRequestReadyToPickUp (sampleRequest) {
		return new Promise((resolve) => {
			const referenceAgent = Utils.safp(Shark.get("userList"), "guid", sampleRequest.userGuid);

			if (referenceAgent) {
				const body = `BuonGiorno ${referenceAgent.firstName},
							
					questa eMail per comunicare che la tua Richiesta di Campionatura <strong>${sampleRequest.__requestTypeLabel}</strong> relativa al Contatto <strong>${sampleRequest.contactName}</strong> è pronta per il ritiro in IPM.

					Buona Giornata,
					IPM HUB
				`;

				const currMessage = Shark.getInstance(null, {
					body,
					senderEMail: "hub-noreply@ipmitalia.it",
					senderName: "IPM HUB",
					subject: "IPM HUB | Richiesta di Campionatura pronta",
					receiverEMail: referenceAgent.email,
					receiverName: referenceAgent.__fullName,
				});
				userManager.sendMessage(currMessage)
				.then(() => resolve({ status: "ok" }));
			}
		});
	}

	sampleRequestShipped (sampleRequest) {
		return new Promise((resolve) => {
			const referenceAgent = Utils.safp(Shark.get("userList"), "guid", sampleRequest.userGuid);

			if (referenceAgent) {
				const body = `BuonGiorno ${referenceAgent.firstName},
							
					questa eMail per comunicare che la tua Richiesta di Campionatura <strong>${sampleRequest.__requestTypeLabel}</strong> relativa al Contatto <strong>${sampleRequest.contactName}</strong> è stata spedita al Contatto.

					Buona Giornata,
					IPM HUB
				`;

				const currMessage = Shark.getInstance(null, {
					body,
					senderEMail: "hub-noreply@ipmitalia.it",
					senderName: "IPM HUB",
					subject: "IPM HUB | Richiesta di Campionatura spedita",
					receiverEMail: referenceAgent.email,
					receiverName: referenceAgent.__fullName,
				});
				userManager.sendMessage(currMessage)
				.then(() => resolve({ status: "ok" }));
			}
		});
	}
}

const communicationManager = new CommunicationManager();

Shark.registerController(communicationManager);

export { communicationManager };
